import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, TextareaAutosize,

} from "@material-ui/core";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

import Checkbox from '@mui/material/Checkbox';


 import React, { useState} from "react";
import axios from "axios";
import { api } from "./api/client";
import Grid from "@mui/material/Grid";
import {FormControlLabel, FormGroup} from "@mui/material";
import IconButton from "@mui/material/IconButton";

export default function ModalBoxSevkiyat(props) {
    const [open, setOpen] = useState(false);
    const [muhasebeMail,setMuhasebeMail] = useState(false);
    const [guvenlikMail,setGuvenlikMail] = useState(false);
    const [teknikOfisMail,setTeknikOfisMail] = useState(false);
    const [satinAlmaMail,setSatinAlmaMail] = useState(false);
    const [pazarlamaMail,setPazarlamaMail] = useState(false);
    const [otomasyonMail,setOtomasyonMail] = useState(false);
    const [elektrikMail,setElektrikMail] = useState(false);
    const [kaliteMail,setKaliteMail] = useState(false);
    const [sevkiyatMail,setSevkiyatMail] = useState(false);
    const [irsaliye,setIrsaliye]= useState(true);
    const [siparisMektubu,setSiparisMektubu]= useState(true);
    const [servisFormu,setServisFormu]= useState(true);
    const [diger,setDiger]= useState(true);
    const [dosyalar,setDosyalar]=useState([]) ;



    const [state, setState] = useState({
        id:props.id,
        sevk_notlari: props.sevk_notu

    });

    const handleChange = name => e => {
        setState({
            ...state,
            [name]: e.target.value
        });
        console.log('state change',state);
    };
    const handleCheck = name => e => {

        setState({
            ...state,
            [name]: false
        });
        console.log('state change',state);
    };
    const handleClickOpen = async () => {
        setOpen(true);
        const res = await api.get('/teklifler/' + props.teklifNo + '/dosyalar');
        const data = res.data

        const files = data.map(d => ({
            "id": d.id,
            "irsaliye": d.irsaliye,
            "servis_formu": d.servis_formu,
            "siparis_mektubu": d.siparis_mektubu,
            "diger": d.diger
        }))
        setDosyalar(files[0]);
        console.log('dosyalar',data)
    };

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <div>
            <IconButton variant="outlined" size={"small"} color="success" onClick={handleClickOpen }>
                <LocalShippingIcon />
            </IconButton>
             <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                maxWidth="md"
            >
                <DialogTitle id="form-dialog-title">Makine Sevkiyatı</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Eposta gönderilecek departmanları seçiniz
                    </DialogContentText>

                    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={12}  >
                            <FormGroup>

                                    <Grid item xs={12}>
                                        <FormControlLabel   control={<Checkbox checked={satinAlmaMail} value={satinAlmaMail || ""}  onChange={(e) => setSatinAlmaMail( e.target.checked)}   />} label="Satın Alma" />
                                        <FormControlLabel   control={<Checkbox checked={guvenlikMail}  value={guvenlikMail  || ""}  onChange={(e) => setGuvenlikMail( e.target.checked)} />} label="Güvenlik" />
                                        <FormControlLabel   control={<Checkbox checked={muhasebeMail}  value={muhasebeMail  || ""}  onChange={(e) => setMuhasebeMail( e.target.checked)}/>} label="Muhasebe" />
                                    </Grid>
                                <Grid item xs={12}>
                                    <FormControlLabel   control={<Checkbox checked={teknikOfisMail}  value={teknikOfisMail  || ""}  onChange={(e) => setTeknikOfisMail( e.target.checked)}  />} label="Teknik Ofis" />
                                    <FormControlLabel   control={<Checkbox checked={pazarlamaMail}  value={pazarlamaMail  || ""}  onChange={(e) => setPazarlamaMail( e.target.checked)} />} label="Pazarlama" />
                                    <FormControlLabel   control={<Checkbox checked={otomasyonMail}  value={otomasyonMail  || ""}  onChange={(e) => setOtomasyonMail( e.target.checked)} />} label="Otomasyon" />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControlLabel   control={<Checkbox checked={sevkiyatMail}  value={sevkiyatMail  || ""}  onChange={(e) => setSevkiyatMail( e.target.checked)} />} label="Sevkiyat" />
                                    <FormControlLabel   control={<Checkbox checked={elektrikMail}  value={elektrikMail  || ""}  onChange={(e) => setElektrikMail( e.target.checked)} />} label="Elektrik" />
                                    <FormControlLabel   control={<Checkbox checked={kaliteMail}  value={kaliteMail  || ""}  onChange={(e) => setKaliteMail( e.target.checked)} />} label="Kalite" />
                                </Grid>

                            </FormGroup>

                        </Grid>
                   </Grid>
                    { (dosyalar.irsaliye ||  dosyalar.siparis_mektubu ||  dosyalar.servis_formu || dosyalar.diger) &&  <DialogContentText>
                          Epostayla gönderilecek dosyaları seçiniz
                    </DialogContentText>}


                    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={12}  >
                            <FormGroup>

                                <Grid item xs={12}>
                                    {dosyalar.irsaliye &&   <FormControlLabel   control={<Checkbox checked={irsaliye} value={irsaliye || ""}  onChange={(e) => setIrsaliye(e.target.checked)}   />} label="İrsaliye" /> }
                                    {dosyalar.siparis_mektubu && <FormControlLabel   control={<Checkbox checked={siparisMektubu}  value={siparisMektubu  || ""}  onChange={(e) => setSiparisMektubu(e.target.checked)} />} label="Sipariş Mektubu" />}

                                </Grid>
                                <Grid item xs={12}>
                                    {dosyalar.servis_formu && <FormControlLabel   control={<Checkbox checked={servisFormu}  value={servisFormu  || ""}  onChange={(e) => setServisFormu(e.target.checked)}  />} label="Servis Formu" />}
                                    {dosyalar.diger && <FormControlLabel   control={<Checkbox checked={diger}  value={diger  || ""}  onChange={(e) => setDiger(e.target.checked)} />} label="Diğer" />}
                                 </Grid>

                            </FormGroup>

                        </Grid>
                    </Grid>

                    <DialogContentText>
                        Sevk Notları Giriniz
                    </DialogContentText>
                    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={5}  >
                            <TextareaAutosize
                                margin="dense"
                                id="sevk_notlari"
                                label="Sevkiyat Notları"
                                type="tel"
                                value={state.sevk_notlari || ""}
                                onChange={handleChange("sevk_notlari")}
                                fullWidth
                                multiline
                                minRows="8"
                                style={{ width: 400 }}
                            />
                        </Grid>


                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        İptal
                    </Button>
                    <Button

                        onClick={
                            async () => {
                                let sevkiyat_duzenleyen= localStorage.getItem('ssh_user_name');

                                //console.log(props.row);
                             await api.post('/teklifler/' + props.id + '/sevk-et?id=' + props.id, {
                                'sevkiyat_notlari': state.sevk_notlari,
                                'pazarlama': pazarlamaMail,
                                'guvenlik': guvenlikMail,
                                 'elektrik':elektrikMail,
                                'teknik_ofis': teknikOfisMail,
                                'satin_alma': satinAlmaMail,
                                'muhasebe': muhasebeMail,
                                'sevkiyat': sevkiyatMail,
                                'irsaliye': irsaliye,
                                'siparis_mektubu':siparisMektubu,
                                 'otomasyon':otomasyonMail,
                                 'servis_formu':servisFormu,
                                'diger': diger,
                                 'kalite':kaliteMail,
                                 'sevkiyat_duzenleyen':sevkiyat_duzenleyen
                             })
                                .then((response) => {
                                    // Success 🎉
                                    console.log(response);
                                    handleClose();
                                    props.sevkEdilmis(true);
                                })
                                .catch((error) => {
                                    // Error 😨
                                    if (error.response) {
                                        /*
                                         * The request was made and the server responded with a
                                         * status code that falls out of the range of 2xx
                                         */
                                        console.log(error.response.data);
                                        console.log(error.response.status);
                                        console.log(error.response.headers);
                                    } else if (error.request) {
                                        /*
                                         * The request was made but no response was received, `error.request`
                                         * is an instance of XMLHttpRequest in the browser and an instance
                                         * of http.ClientRequest in Node.js
                                         */
                                        console.log(error.request);
                                    } else {
                                        // Something happened in setting up the request and triggered an Error
                                        console.log('Error', error.message);
                                    }
                                    console.log(error.config);
                                });
                            setState({open:false});
                        }}
                        color="primary"
                    >
                        Gönder
                    </Button>
                </DialogActions>
            </Dialog></div>
    )
}

